
import React from 'react';

const ProblemSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center space-y-8">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
            Are You Managing Your <span className="text-orange-600">Greatest Litigation Risks?</span>
          </h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="text-xl lg:text-2xl text-gray-700 leading-relaxed font-light">
              The use of Generative AI is not a technical problem; it is a litigation problem. Every model you deploy could be generating risks to your business, your reputation, and your balance sheet. Consider these:
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 mt-12">
            <div className="bg-orange-50 border-l-4 border-orange-500 p-8 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-scales-line text-white text-xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-orange-700">Regulatory Discrimination</h3>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed">
                Algorithmic bias leading to discriminatory outcomes that violate federal and state regulations, 
                resulting in costly fines and lost business opportunities.
              </p>
            </div>
            
            <div className="bg-amber-50 border-l-4 border-amber-500 p-8 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-amber-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-shield-cross-line text-white text-xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-amber-700">Confidentiality Breaches</h3>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed">
                Data leakage and privacy violations through AI model training and inference, 
                exposing your organization to litigation and regulatory penalties.
              </p>
            </div>
          </div>
          
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white p-8 rounded-lg mt-12">
            <div className="text-center">
              <p className="text-xl lg:text-2xl text-gray-100 font-light leading-relaxed">
                <strong className="text-white font-semibold">This requires sophisticated counsel.</strong> I translate complex ethical and legal principles into the robust, auditable policy frameworks your organization needs to navigate and mitigate your most complex AI litigation risks.
              </p>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
